import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Layout Grid element, used to define a grid to wrap griditems
 *
 * @slot - Unnamed slot (deafault)
 * @prop - grid4 - optional, used to create a 4 column grid (default 3)
 * @prop {String} title - optional, used to display the desired title
 * @prop {String} subtitle - optional, used to display the desired subtitle
 * @prop {Boolean} light - optional, used to display the title and subtitle in white color

 *
 */
let SDBLayoutCatalogRow = class SDBLayoutCatalogRow extends LitElement {
    constructor() {
        super(...arguments);
        this.title = '';
        this.count = 1;
    }
    render() {
        return html `
            <div id="content">
                <div id="titleBar">
                    <div class="titleWrapper">
                        <span class="title" part="title">${this.title}</span>
                        <span>|</span>
                        <span class="count" part="count">${this.count}</span>
                    </div>
                    <div id="navigation">
                        <sdb-content-iconbutton
                            size="15"
                            icon="fal fa-chevron-left"
                            @click="${this._scrollPrev}"
                        ></sdb-content-iconbutton>
                        <sdb-content-iconbutton
                            size="15"
                            icon="fal fa-chevron-right"
                            @click="${this._scrollNext}"
                        ></sdb-content-iconbutton>
                    </div>
                </div>
                <div id="cardWrapper">
                    <div id="top"></div>
                    <slot></slot>
                    <div id="bottom"></div>
                </div>
            </div>
        `;
    }
    _scrollPrev() {
        var _a;
        const wrapper = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#cardWrapper');
        // top?.scrollIntoView({ behavior: 'smooth' });
        wrapper === null || wrapper === void 0 ? void 0 : wrapper.scrollBy({ top: -350, behavior: 'smooth' });
    }
    _scrollNext() {
        var _a;
        const wrapper = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#cardWrapper');
        wrapper === null || wrapper === void 0 ? void 0 : wrapper.scrollBy({ top: 350, behavior: 'smooth' });
    }
};
SDBLayoutCatalogRow.styles = [
    elements,
    css `
            :host {
                width: 100vw;
                margin-left: calc(-50vw + 50%);
                margin-right: calc(-50vw + 50%);
                display: block;
            }

            :host #content {
                position: relative;

                height: calc(
                    175px + 1px + 30px + 40px
                ); /* card + scrollbar + title + margin-bottom */
                margin: 0 auto;
                max-width: 1400px;
                width: calc(100% - 60px);
                padding: 0 30px;

                display: grid;
                grid-template-rows: 30px auto;
                grid-template-columns: 1fr;
                grid-column-gap: 15px;
                grid-template-areas:
                    'titlebar'
                    'cards';
            }

            ::-webkit-scrollbar {
                width: 1px;
                height: 1px;
            }

            ::-webkit-scrollbar-button {
                width: 1px;
                height: 1px;
            }

            :host #cardWrapper {
                grid-area: cards;
                position: absolute;
                top: 0px;
                left: 0px;
                display: grid;
                width: calc(248px);
                height: 93vw;
                max-height: 1400px;
                margin: 0px;
                padding-top: 1px;
                overflow: hidden auto;
                transform: rotate(-90deg) translateY(-248px);
                transform-origin: right top;
            }

            @media (pointer: coarse) {
                :host #cardWrapper {
                    overflow-x: scroll; /* Must be 'scroll' not 'auto' */
                    -webkit-overflow-scrolling: touch;
                }
            }

            :host([light]) div#title > span {
                color: var(--text-light);
            }

            #titleBar {
                grid-area: titlebar;
                display: grid;
                grid-template-columns: 1fr 100px;
                grid-template-areas: 'title . nav';
                width: 93vw;
                max-width: 1400px;
                height: 30px;
            }

            .titleWrapper {
                display: block;
                grid-area: title;
                height: 30px;
                width: fit-content;
            }

            #titleBar > div.titleWrapper > span {
                display: inline-block;
                font-size: 1em;
                color: var(--text-primary);
                width: auto;
                padding: 0 5px;
            }

            #navigation {
                grid-area: nav;
                display: flex;
                padding: 0 20px;
            }

            #navigation > sdb-content-iconbutton {
                margin: 0 5px;
            }

            @media (max-width: 854px) {
                #navigation {
                    justify-content: space-around;
                }

                #cardWrapper {
                    height: 90vw !important;
                }
            }

            @media (pointer: coarse) {
                #cardWrapper {
                    overflow-x: scroll; /* Must be 'scroll' not 'auto' */
                    -webkit-overflow-scrolling: touch;
                }
            }
        `,
];
__decorate([
    property({ type: String })
], SDBLayoutCatalogRow.prototype, "title", void 0);
__decorate([
    property({ type: Number })
], SDBLayoutCatalogRow.prototype, "count", void 0);
SDBLayoutCatalogRow = __decorate([
    customElement('sdb-layout-catalogrow')
], SDBLayoutCatalogRow);
export { SDBLayoutCatalogRow };
//# sourceMappingURL=sdb-layout-catalogrow.js.map